import { useEffect } from "react";

const useKiwiWidget = () => {
  useEffect(() => {
    if (window.kiwi?.init) {
      window.kiwi.init("", "7ofiXtD37J4Uu3gAg0r8y04pmedb83k5", {});
    }
  }, [!!window.kiwi.init]);
};

export default useKiwiWidget;
